import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';
import { User } from '../../types/users/users';

export interface ChangeOrganizacionDTO {
  user_id: UUID;
  organizacion_id: UUID;
}

export const changeOrganizacion = async (
  data: ChangeOrganizacionDTO,
): Promise<Result<User, APIValidationError>> => {
  return validatedApiCall<User>(
    `/api/miembros/${data.user_id}/change_organizacion`,
    {
      method: 'PUT',
      auth: true,
      body: JSON.stringify(data),
    },
  );
};
